import React from 'react';
import { BodyText, Button, DataGrid, NavigationItem } from 'ui-toolkit';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { formatPhoneNumber } from '../../utilities/shared/formatPhoneNumber';
import { ILenderUserData, IPresentationLenderUserData } from '../../types/lenders/ILenderUser';
import { IContactFunctionData } from '../../types/contacts/IContactFunctionData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { IPresentationClientUserData } from '../../types/clients';

interface ILenderContactsTableProps {
  data: ILenderUserData[];
  loading: boolean;
  onEditContact: (contact: IPresentationLenderUserData) => void;
  contactFunctions: IContactFunctionData[];
}

export const LenderContactsTable: React.FC<ILenderContactsTableProps> = ({
  data,
  loading,
  onEditContact,
  contactFunctions,
}) => {
  const columns: IBootstrapTableColumnProps[] = [
    {
      text: 'Function(s)',
      dataField: 'functions',
      sort: true,
      formatter: (cell: string[]) => {
        if (cell && cell.length > 1) {
          return 'Multiple';
        }
        if (cell && cell.length === 1) {
          const contactFunction = contactFunctions.find((func) => func.id === cell[0]);
          return contactFunction ? contactFunction.label : '';
        }
        return '';
      },
    },
    {
      text: 'Name',
      dataField: 'firstName',
      sort: true,
      formatter: (cell: string, row) => (
        <>
          {(row as IPresentationLenderUserData).firstName} {(row as IPresentationLenderUserData).lastName}
        </>
      ),
    },
    {
      text: 'Email',
      dataField: 'email',
      sort: true,
      formatter: (cell, row) => <NavigationItem href={`mailto:${cell}`} text={cell} isActive isInline />,
    },
    {
      text: 'Phone',
      dataField: 'phoneNumber',
      sort: true,
      formatter: (cell: string) => <>{formatPhoneNumber(cell || '')}</>,
    },
    {
      text: 'Notes',
      dataField: 'notes',
      sort: true,
      formatter: (cell, row) => <BodyText style={{ whiteSpace: 'pre-line' }}>{cell}</BodyText>,
    },
    {
      text: 'Options',
      dataField: 'id',
      formatter: (cell, row) => (
        <Button
          intent={'ghost'}
          title={'Edit User'}
          onClick={() => onEditContact(row as IPresentationClientUserData)}
        >
          <FontAwesomeIcon icon={faEdit} />
        </Button>
      ),
    },
  ];

  return (
    <>
      <DataGrid columns={columns} keyField={'key'} data={data} loading={loading} />
    </>
  );
};
